import * as Yup from 'yup';
export const initialLevelValues = {
    imageUrl: undefined,
    title: '',
};
export const levelSchema = Yup.object().shape({
    title: Yup.string().required(),
});
//# sourceMappingURL=level.js.map